import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGestureSwipeHorizontal3 = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "gesture-swipe-horizontal-3" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M10.608,20.748,6.819,17.655a1.639,1.639,0,0,1-.566-1.676h0a1.638,1.638,0,0,1,2.321-1.068l1.174.587V8.748a1.5,1.5,0,0,1,1.5-1.5h0a1.5,1.5,0,0,1,1.5,1.5v4.5l1.993.333a3,3,0,0,1,2.507,2.959v4.208"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: .748,
			y1: 7.248,
			x2: 5.998,
			y2: 7.248
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "4.498 3.498 0.748 7.248 4.498 10.998"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 15.748,
			y1: 7.248,
			x2: 23.248,
			y2: 7.248
		}),
		/* @__PURE__ */ _jsx("polyline", {
			className: "a",
			points: "19.498 3.498 23.248 7.248 19.498 10.998"
		})
	]
});
export default SvgGestureSwipeHorizontal3;
